import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import Grow from "@material-ui/core/Grow";
import Aos from "aos";
import "aos/dist/aos.css";
import Fade from "@material-ui/core/Fade";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

class Navbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      prevScrollpos: window.pageYOffset,
      visible: true,
      top: false,
      open: false,
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  // Adds an event listener when the component is mount.
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    Aos.init({ duration: 1000 });
  }

  // Remove the event listener when the component is unmount.
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  closeNav = () => {
    document.getElementById("myNav").style.width = "0%";
  };

  openNav = () => {
    document.getElementById("myNav").style.width = "100%";
  };

  // Hide or show the menu.
  handleScroll = () => {
    const { prevScrollpos } = this.state;

    // console.log(prevScrollpos);
    const currentScrollPos = window.pageYOffset;
    if (currentScrollPos > 80) {
      this.setState({ top: true, visible: false });
    } else {
      this.setState({ top: false, visible: true });
    }
    // const visible = prevScrollpos > currentScrollPos;

    // this.setState({
    //   prevScrollpos: currentScrollPos,
    //   visible,
    // });
  };

  render() {
    return (
      <div id="Navbar">
        <div className={this.state.top ? "active bgsmoke boxsh" : "active bgsmoke borderbottom"}>
          <div className="container" style={{ paddingTop: "20px" }}>
            <div
              className={this.state.top ? "row pder nav_padding_reduce" : "row pder nav_padding"}
            >
              <div id="myNav" class="overlay">
                <a href="javascript:void(0)" class="closebtn" onClick={this.closeNav}>
                  &times;
                </a>
                <div class="overlay-content">
                  <a href="/about-us">
                    {/* <i class="fas fa-address-card"></i>  */}
                    About
                  </a>
                  <a href="/">
                    {/* <i class="fas fa-briefcase"></i>  */}
                    Services
                  </a>
                  <a href="/blog">
                    {/* <i class="fas fa-globe-americas"></i>  */}
                    Blogs
                  </a>
                </div>
              </div>

              <div className="col-4 desktoponly">
                {/* <h1>CA LABS</h1> */}
                <Fade in={true}>
                  <Link to="/">
                    <img
                      className="pder"
                      src={require("../../Assets/ca-labs-logo.png")}
                      width={this.state.top ? "95px" : "115px"}
                    />
                  </Link>
                </Fade>
              </div>
              <div className="col-4 d-flex desktoponly pb_10px">
                <a className="nav_link" href="/">
                  <p
                    className={
                      window.location.pathname.split("/")[1] == "services" ||
                      window.location.pathname == "/"
                        ? "mauto fw500 navrouteactive"
                        : "mauto fw500 "
                    }
                  >
                    SERVICES
                  </p>
                </a>
                <a className="nav_link" href="/blog">
                  <p
                    className={
                      window.location.pathname == "/blog"
                        ? "mauto fw500 navrouteactive"
                        : "mauto fw500 "
                    }
                  >
                    EXPLORE
                  </p>
                </a>
                <a className="nav_link" href="/about-us">
                  <p
                    className={
                      window.location.pathname == "/about-us"
                        ? "mauto fw500 navrouteactive"
                        : "mauto fw500 "
                    }
                  >
                    ABOUT US
                  </p>
                </a>
              </div>
              <div className="col-4 desktoponly ">
                <Fade in={true}>
                  <p
                    onClick={this.onOpenModal}
                    data-aos="fade-down"
                    className={
                      this.state.top
                        ? "fr pder fbold intouchbtn_reduce"
                        : "fr pder fbold intouchbtn"
                    }
                  >
                    Get in touch <i class="fas fa-arrow-right"></i>
                  </p>
                </Fade>
                <Modal open={this.state.open} onClose={this.onCloseModal} center>
                  <br />
                  <h2>REACH US:</h2>
                  <p>You can contact us by scheduling a meet.</p>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    href="https://calendly.com/ca_labs/general"
                    target="_blank"
                  >
                    <p
                      // data-aos="fade-down"
                      className={
                        this.state.top ? " pder fbold intouchbtn_reduce" : " pder fbold intouchbtn"
                      }
                    >
                      Schedule a meet <i class="fas fa-arrow-right"></i>
                    </p>
                  </a>
                  <br />
                  <p className="text-muted">OR</p>
                  <p>
                    You can contact us by whatsapp/call on <b>8851956910</b>.
                  </p>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    href="tel:8851956910"
                    target="_blank"
                  >
                    <button
                      type="button"
                      class="btn btn-primary fullbtn mr7"
                      style={{ width: "100%" }}
                    >
                      CALL/Whatsapp
                    </button>
                  </a>
                  <br />
                </Modal>
              </div>
              {/* MOBILE NAVBAR */}
              <div className="col-7 mobileonly">
                {/* <h1>CA LABS</h1> */}
                <span className="burger_icon" onClick={this.openNav}>
                  ☰{" "}
                </span>
                <Link to="/">
                  <img
                    className="pder"
                    src={require("../../Assets/ca-labs-logo.png")}
                    width={this.state.top ? "95px" : "115px"}
                  />
                </Link>
              </div>
              {/* <div className="col-1 mobileonly"></div> */}
              <div className="col-5 mobileonly">
                <Fade in={true}>
                  <a
                    style={{ textDecoration: "none", color: "black" }}
                    href="https://calendly.com/ca_labs/general"
                    target="_blank"
                  >
                    <p
                      className={
                        this.state.top
                          ? "fr pder fbold intouchbtn_reduce"
                          : "fr pder fbold intouchbtn"
                      }
                    >
                      Get in touch <i class="fas fa-arrow-right"></i>
                    </p>
                  </a>
                </Fade>
              </div>
            </div>
            {/* <div>
              <Fade in={true}>
                <div
                  className={this.state.top ? "d-flex pder padding_reduce" : "d-flex pder paddings"}
                >
                  <p className="nav_topics fbold">GST</p>
                  <p className="nav_topics fbold">TAX</p>
                  <p className="nav_topics fbold">AUDIT</p>
                  <p className="nav_topics fbold">ITR</p>
                  <p className="nav_topics tblue fbold">
                    <i class="fas fa-newspaper"></i> FIN-NEWS{" "}
                  </p>
                </div>
              </Fade>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;
